/* unplugin-vue-components disabled */import script from "./MainContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainContent.vue?vue&type=script&setup=true&lang=ts"

import "./MainContent.vue?vue&type=style&index=0&id=94fce76e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94fce76e"]])

export default __exports__